<template>
  <span
    class="text-background bg-background-fg/30 relative inline-flex items-center justify-between rounded-full px-3 py-1 text-xs font-medium"
    :style="{ backgroundColor: colorHexCode }"
  >
    <template v-if="productTag?.isHidden">
      <IconHeroiconsSolidEyeOff class="mr-2" />
    </template>
    {{ productTag?.label }}

    <template v-if="removable">
      <button
        type="button"
        class="ml-2 flex h-3 w-3 items-center justify-center"
        @click="emit('click-remove')"
      >
        <IconHeroiconsSolidX />
      </button>
    </template>
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  productTagId: string
  removable?: boolean
}>()

const emit = defineEmits<{
  (event: "click-remove"): void
}>()

const { getById } = useProductTags()
const productTag = computed(
  () => getById(props.productTagId).value
)

const colorHexCode = computed(() =>
  productTag.value
    ? PRODUCT_TAG_COLOR_MAP[productTag.value.color]?.color
    : undefined
)
</script>
